module.exports = __webpack_public_path__ + "img/52002771_L.1c522610.png";